import type { CheckoutSession } from "@/react/types/Paywalls/Checkout/Session";

export const buildMainOfferRoute = (checkoutPath: string): string =>
  `/checkout/${checkoutPath}`;

export const buildOfferRoute = (
  checkoutPath: string,
  stepId: number | string,
): string => `/checkout/${checkoutPath}/step/${stepId}`;

export const buildCheckoutConfirmationRoute = (
  checkoutPath: string,
  sessionId: number,
): string => `/checkout/${checkoutPath}/confirmation/${sessionId}`;

export const getCommunityRootUrl = (
  session: CheckoutSession | null | undefined,
): string => session?.settings.community_root_url || "/";
